export const OnboardingTaskId = {
  ConnectCluster: 'connect-cluster',
  CreateAllocationGroup: 'create-allocation-group',
  CreateBudget: 'create-budget',
  AskOpsPilot: 'ask-opspilot',
} as const;

export type OnboardingTaskId =
  (typeof OnboardingTaskId)[keyof typeof OnboardingTaskId];
